import { render, staticRenderFns } from "./FileConverterButton.vue?vue&type=template&id=45a913bd&"
import script from "./FileConverterButton.vue?vue&type=script&lang=js&"
export * from "./FileConverterButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports